import Navbar from './components/Navbar';
import HeroBanner from './components/HeroBanner';
import ServicesSection from './components/ServicesSection';
import AboutSection from './components/AboutSection';
import PortfolioSection from './components/PortfolioSection';
import ContactSection from './components/ContactSection';
import SubscribeSection from './components/SubscribeSection';
import Footer from './components/Footer';
import PopupBanner from './components/PopupBanner';

const SITE_URL = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

const localBusinessJsonLd = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "BeautySalon",
  "name": "THIRD STUDIO",
  "url": SITE_URL,
  "image": `${SITE_URL}/og-image.jpg`,
  "description": "Professional makeup artist and styling studio specializing in bridal makeup, KOL styling, SFX makeup, and makeup classes in Seri Kembangan, Selangor, Malaysia.",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Unit C-LG-07, Sfera Residency, Jalan Atmosphere 1, Bandar Putra Permai",
    "addressLocality": "Seri Kembangan",
    "addressRegion": "Selangor",
    "postalCode": "43300",
    "addressCountry": "MY"
  },
  "telephone": "+60174866108",
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 3.0201,
    "longitude": 101.7085
  },
  "sameAs": [
    "https://www.facebook.com/insglobalmy/",
    "https://www.instagram.com/insglobalmy_official/"
  ],
  "hasMap": "https://share.google/RmT2JJsHzC7dbZJJl",
  "priceRange": "$$",
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
      "opens": "09:00",
      "closes": "18:00"
    }
  ]
});

const breadcrumbJsonLd = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": SITE_URL
    }
  ]
});

const webPageJsonLd = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "THIRD STUDIO | Professional Makeup Artist & Bridal Styling Seri Kembangan Selangor",
  "url": SITE_URL,
  "description": "THIRD STUDIO – Professional makeup artist and styling studio in Seri Kembangan, Selangor. Specializing in bridal makeup, KOL styling, SFX makeup, personal makeup classes, and brand campaign shoots.",
  "inLanguage": "en-MY",
  "isPartOf": {
    "@type": "WebSite",
    "url": SITE_URL,
    "name": "THIRD STUDIO"
  }
});

export default function HomePage() {
  return (
    <div className="min-h-screen">
      {/* Schema.org JSON-LD */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: localBusinessJsonLd }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: breadcrumbJsonLd }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: webPageJsonLd }} />

      <PopupBanner />
      <Navbar />
      <HeroBanner />
      <ServicesSection />
      <AboutSection />
      <PortfolioSection />
      <ContactSection />
      <SubscribeSection />
      <Footer />

      {/* WhatsApp floating button */}
      <a
        href="https://wa.me/60125618333?text=Hi, i am interested to know more."
        target="_blank"
        rel="nofollow noreferrer"
        className="fixed bottom-4 sm:bottom-6 right-4 sm:right-6 w-12 h-12 sm:w-14 sm:h-14 bg-green-500 rounded-full flex items-center justify-center hover:bg-green-600 transition-colors cursor-pointer z-50"
        title="WhatsApp Us"
      >
        <i className="ri-whatsapp-line text-xl sm:text-2xl text-white" />
      </a>

      {/* Back to top */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-4 sm:bottom-6 right-20 sm:right-24 w-9 h-9 sm:w-10 sm:h-10 bg-gray-700 text-white rounded-full flex items-center justify-center hover:bg-gray-600 transition-colors cursor-pointer z-50"
        title="Back to top"
      >
        <i className="ri-arrow-up-line text-base sm:text-lg" />
      </button>
    </div>
  );
}
